





















import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Exco extends Vue {
  exco:Array<Object> = []

  mounted () {
    axios.get('/json/exco.json').then(
      response => { this.exco = response.data }
    )
  }
}
